import { ApiService } from '../services/apiService';

const VISITOR_ID_KEY = 'mig_visitor_id';
const VISIT_SENT_KEY = 'mig_visit_sent';

function createVisitorId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `v_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
}

export function getVisitorId(): string {
  try {
    const existing = localStorage.getItem(VISITOR_ID_KEY);
    if (existing && /^[a-zA-Z0-9_-]{8,64}$/.test(existing)) {
      return existing;
    }
    const created = createVisitorId().replace(/[^a-zA-Z0-9_-]/g, '');
    localStorage.setItem(VISITOR_ID_KEY, created);
    return created;
  } catch {
    return createVisitorId().replace(/[^a-zA-Z0-9_-]/g, '');
  }
}

function sendEvent(eventType: 'visit' | 'puzzle_start' | 'puzzle_solve' | 'bot_start' | 'bot_finish', detail?: string) {
  ApiService.trackVisitorEvent(getVisitorId(), eventType, detail).catch(() => {
    /* non-blocking */
  });
}

export function trackVisit() {
  const isMember = !!localStorage.getItem('authToken');
  try {
    const already = sessionStorage.getItem(VISIT_SENT_KEY);
    if (already === 'member') return;
    if (already === 'guest' && !isMember) return;
    sessionStorage.setItem(VISIT_SENT_KEY, isMember ? 'member' : 'guest');
  } catch {
    /* private mode */
  }
  sendEvent('visit');
}

export function trackPuzzleStart(puzzleId: number) {
  sendEvent('puzzle_start', String(puzzleId));
}

export function trackPuzzleSolve(puzzleId: number) {
  sendEvent('puzzle_solve', String(puzzleId));
}

export function trackBotStart(mode: string) {
  sendEvent('bot_start', mode);
}

export function trackBotFinish(mode: string) {
  sendEvent('bot_finish', mode);
}
